import { useIntl } from 'react-intl';
import { FaSpinner } from 'react-icons/fa';
import { Table as AntdTable, TableProps } from 'antd';
import DefaultEmpty from '../DefaultEmpty';

import './style.less';

export type { ColumnsType } from 'antd/es/table/interface';

// eslint-disable-next-line
function Table<T extends object>(props: TableProps<T>) {
  const intl = useIntl();

  return (
    <AntdTable<T>
      {...props}
      size="middle"
      pagination={false}
      locale={{
        emptyText: <DefaultEmpty className="default-table-empty" />,
      }}
      loading={{
        spinning: props.loading as boolean,
        indicator: <FaSpinner className="loading-spinner" />,
        tip: intl.formatMessage({ id: 'commons.form.loading' }),
      }}
    />
  );
}

export default Table;
